import React from 'react';
import { Circle, ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

export interface AppleCalendarIconProps extends SvgProps {
  size?: number;
}

export const AppleCalendarIcon: React.FC<AppleCalendarIconProps> = ({
  size = 80,
  ...props
}) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
      <Defs>
        <ClipPath id="circleClip">
          <Circle cx="32" cy="32" r="32" />
        </ClipPath>
      </Defs>
      <G transform="scale(1, -1) translate(0, -64)">
        {/* White circle background */}
        <Circle cx="32" cy="32" r="32" fill="#FFFFFF" />
        {/* Calendar body - rounded rectangle */}
        <Rect
          x="12.86035"
          y="11.56055"
          width="37.94922"
          height="31.57715"
          rx="3"
          ry="3"
          fill="#FFFFFF"
        />
        {/* Red top bar - clipped to circle for rounded top */}
        <G clipPath="url(#circleClip)">
          <Rect x="0" y="50" width="64" height="14" fill="#E9574F" />
        </G>
        {/* Number 15 text */}
        <Path
          d="M25.49219 17V38.1377H23.51465L17.86035 34.22656V32.10254L23.32422 35.89648H23.5V17H25.49219ZM38.51465 16.56055C42.74805 16.56055 45.80957 19.53418 45.80957 23.72363V23.75293C45.80957 27.81055 42.89453 30.78418 38.93945 30.78418 36.87402 30.78418 35.02832 29.89062 34.01758 28.35254H33.82715L34.67676 36.33594H44.56445V38.1377H33.08008L31.9082 26.22852H33.68066C33.91504 26.63867 34.19336 27.00488 34.50098 27.3125 35.52637 28.44043 36.97656 29.04102 38.63184 29.04102 41.63477 29.04102 43.84668 26.78516 43.84668 23.70898V23.67969C43.84668 20.57422 41.63477 18.34766 38.54395 18.34766 35.84863 18.34766 33.76855 20.09082 33.47559 22.27344L33.46094 22.37598H31.54199L31.55664 22.22949C31.87891 19.02148 34.70605 16.56055 38.51465 16.56055Z"
          fill="#000000"
        />
      </G>
    </Svg>
  );
};

AppleCalendarIcon.displayName = 'AppleCalendarIcon';
